export default {
	invalidAccount: "Invalid user. Please sign up for an account to access Opre.",
	unknownError: "An unknown error has occurred. Please contact Opre for assistance.",
};
